import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Input, Button, ButtonGroup, Label } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { Loading, DownloadingPorts } from './LoadingComponent';
import { connect } from 'react-redux';
import { CSVLink } from "react-csv";
import { RenderVirtualTable } from './TableComponent';
import { BarPlot, MultBarPlot, MultLineTsPlot, ScatterPlot } from './PlotComponent';
import { transpose, pick, custom_sort_by, 
         reordered_array_keys, custom_sort_keys, sort_array_js } from './Functions';
import { colors_sura } from '../shared/data';
import { postRequest } from '../redux/ActionCreators';


const mapStateToProps = state => {
  return {
    compar_params: state.compar_params,
    user_wm: state.user_wm,
    port_metrics_compar: state.port_metrics_compar
  };
};

class PortComparMetrics extends Component {
    constructor(props){
        super(props);
        this.state = {
            msg: null,
            exp_var: "AssetClass",
            port_sel: null,
            ret_period:'YTD',
            downloading_portfolios:false,
            show_series:true,
            show_labels:false
        };
    }

    downloadPortolios = async () => {
      this.setState({downloading_portfolios:true});
      try {
        const url = await postRequest({
          port_id:this.props.port_metrics_compar.data.names, 
          last_update:true,
          res_url:true
        }, 'port_saa');

        if (url.status!=="error"){
          window.location.replace(String(url));
        } else {
          this.setState({msg:url.msg});
        }
        this.setState({downloading_portfolios:false});
      } catch(error) {
        console.log(error.message);
        this.setState({
          downloading_portfolios:false
        });
      }
    }

    render(){
        if(this.props.port_metrics_compar.isLoading){
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Resumen de Portafolios</h4>
                  </div>
                </div>
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Breadcrumb>
                        <BreadcrumbItem><Link to='/portfolio/compar/params'>Comparación</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Resultados</BreadcrumbItem>
                    </Breadcrumb>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <Loading />
                </div>
              </div>
          );
        } else if(this.props.port_metrics_compar.errMess){
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Resumen de Portafolios</h4>
                  </div>
                </div>
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Breadcrumb>
                        <BreadcrumbItem><Link to='/portfolio/compar/params'>Comparación</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Resultados</BreadcrumbItem>
                    </Breadcrumb>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-5 m-5">
                    <p>{this.props.port_metrics_compar.errMess}</p>
                  </div>
                </div>
              </div>
          );
        } else if(this.props.port_metrics_compar.data==null){
          return(
              <div className="container">
                <div className="row mt-5 justify-content-center">
                  <div className="col-auto">
                      <h4>Resumen de Portafolios</h4>
                  </div>
                </div>
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Breadcrumb>
                        <BreadcrumbItem><Link to='/portfolio/compar/params'>Comparación</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Resultados</BreadcrumbItem>
                    </Breadcrumb>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-5 m-5">
                    <p>No hay datos disponibles.</p>
                  </div>
                </div>
              </div>
          );
        } else {
            // const exp_table = this.props.port_metrics_compar.data.ports_exp[this.state.exp_var]
            //   .sort(sort_by(this.props.port_metrics_compar.data.names[0], "desc"));
            
            const exp_table = custom_sort_by(transpose(this.props.port_metrics_compar.data.ports_exp[this.state.exp_var], this.state.exp_var, "Portafolio"), "Portafolio", this.props.port_metrics_compar.data.names);
            const valid_metrics = ["Retorno Promedio Anual.","Volatilidad Anual.", "VeR 99%", "Duración", "Sharpe", "Drawdown"];
            const rets_summ_table = transpose(
              this.props.port_metrics_compar.data.rets_summ.filter(item=>valid_metrics.includes(item["Métrica"])).map(item => pick(item, ['Métrica'].concat(this.props.port_metrics_compar.data.names)))
            , "Métrica", "Portafolio");
            const real_rets = this.props.port_metrics_compar.data.total_rets.filter(k=>k.Portafolio==(this.state.port_sel || this.props.port_metrics_compar.data.names[0])).slice(-10);
            const expect_rets = this.props.port_metrics_compar.data.conf_ints
                                .filter(k=>k.Portafolio==(this.state.port_sel || this.props.port_metrics_compar.data.names[0]))
                                .map(k=>pick(k, ["Periodo", "Límite Inferior", "Límite Superior"]));
            const neg_rets_perc = transpose(this.props.port_metrics_compar.data.neg_rets_perc, "Periodo", "Portafolio");
            
            // Assets
            const rets_summ_assets_table = transpose(
              this.props.port_metrics_compar.data.rets_summ_assets
                .filter(item=>valid_metrics.includes(item["Métrica"]))
            , "Métrica", "Activo");
            
            const real_rets_assets = reordered_array_keys(this.props.port_metrics_compar.data.real_rets_assets, 'Periodo');
            const real_rets_assets_trans = real_rets_assets ? transpose(real_rets_assets, "Periodo", "Portafolio") : null;
            const date_ind = (new Date(this.props.port_metrics_compar.data.avail_dates[0])) < (new Date()).setFullYear((new Date()).getFullYear() - 10);
            console.log(date_ind);
            return(
                <div className="container">
                    <div className="row m-3 justify-content-center">
                      <div className="row mt-5 justify-content-center">
                        <div className="col-auto">
                            <h4>Resumen de Portafolios</h4>
                        </div>
                      </div>
                      <div className="col-auto">
                        <Breadcrumb>
                            <BreadcrumbItem><Link to='/portfolio/compar/params'>Parámetros</Link></BreadcrumbItem>
                            <BreadcrumbItem active>Resultados</BreadcrumbItem>
                        </Breadcrumb>
                      </div>
                    </div>
                    <div className="row m-4 justify-content-center">
                      <div className='col' id="exp">
                        <h5>Exposición</h5>
                        <a className='linkcol' href='#risk_ret'>riesgo-retorno&darr; {'          '}</a>
                        <a className='linkcol' href='#rets'>análisis retornos&darr; {'          '}</a>
                        {date_ind ? <a className='linkcol' href='#neg_rets'>retornos negativos&darr; {'          '}</a> : null}
                        <a className='linkcol' href='#assets'>activos&darr;</a>
                      </div>
                    </div>
                    <div className="row m-1 justify-content-center">
                      <div className='col-6 col-lg-2'>
                          <Input 
                              type="select"
                              value={this.state.exp_var}
                              onChange={(e)=>this.setState({exp_var:e.target.value})}
                              >
                              {Object.keys(this.props.port_metrics_compar.data.ports_exp).map((x,i)=>{
                                return <option key={i}>{x}</option>;
                              })}
                          </Input>
                      </div>
                    </div>
                    <div className="row m-5 justify-content-start">
                      <div className='col-lg-6'>
                        <div className="row justify-content-center">
                          <div className={`col-auto ${exp_table.length<4 ? "mt-4" : "mt-0"}`}>
                            <RenderVirtualTable 
                              data={exp_table} 
                              to_perc={[false].concat(new Array(Object.keys(exp_table[0]).length - 1).fill(true))}
                              cell_width={["200px"].concat(new Array(this.props.port_metrics_compar.data.names.length).fill("70px"))}
                              item_size={45}
                              fontsize={12}
                              style="black"
                            />
                          </div>
                        </div>
                        <div className='row m-0 justify-content-center align-items-center'>
                          <div className='col-auto'>
                            <Button
                              className='link-btn'
                              onClick={this.downloadPortolios}
                            >
                              {this.state.downloading_portfolios ? <DownloadingPorts/> : <small>Descargar portfolios &darr;</small>}
                            </Button>
                          </div>
                          <div className='col-auto'>
                            <CSVLink className='link-btn' data={exp_table} filename="exp_table"><small>Descargar exposición &darr;</small></CSVLink>
                          </div>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <MultBarPlot 
                          data={this.props.port_metrics_compar.data.ports_exp[this.state.exp_var].map(item=>custom_sort_keys(item, this.props.port_metrics_compar.data.names))}
                          nameKey={this.state.exp_var}
                          vertical={false}
                          angle={0}
                          xtype="category" 
                          ytype="number"
                          colors={colors_sura}
                          ypercAxis={true}
                          percTooltip={true}
                          width={600}
                          ml={50}
                          top={30}
                          interval={0}
                          height={450}
                          barsize={20}
                          legend={true}
                        />
                      </div>
                    </div>
                    <div className="row m-4 justify-content-center">
                      <div className='col'>
                        <hr></hr>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center">
                      <div className='col' id="risk_ret">
                        <h5>Riesgo - Retorno</h5>
                        <a className='linkcol' href='#exp'>exposición&uarr; {'          '}</a>
                        <a className='linkcol' href='#rets'>análisis retornos&darr; {'          '}</a>
                        {date_ind ? <a className='linkcol' href='#neg_rets'>retornos negativos&darr; {'          '}</a> : null}
                        <a className='linkcol' href='#assets'>activos&darr;</a>
                      </div>
                    </div>
                    <div className="row m-2 justify-content-center">
                      <div className='col-auto'>
                        <small>{this.props.port_metrics_compar.data.avail_dates[0]}/{this.props.port_metrics_compar.data.avail_dates[1]}</small>
                      </div>
                    </div>
                    <div className="row m-5 justify-content-center">
                      <div className='col-lg-6'>
                        <div className="row justify-content-center">
                          <div className={`col-auto ${rets_summ_table.length<4 ? "mt-4" : "mt-0"}`}>
                            <RenderVirtualTable 
                              data={rets_summ_table} 
                              to_perc={[false, true, true, false, true, false, true]}
                              cell_width={["150px", '65px', '65px', '65px', '65px', '65px', '65px']}
                              item_size={45}
                              fontsize={12}
                              style="black"
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col'>
                            <CSVLink className='link-btn' data={rets_summ_table} filename="rets_summ_table"><small>Descargar métricas &darr;</small></CSVLink>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className="row justify-content-center">
                          <div className='col-auto'>
                            <ButtonGroup size='sm'>
                              <Button
                                color="dark"
                                outline
                                onClick={() => this.setState({show_series:!this.state.show_series})}
                                active={this.state.show_series}
                              >
                                series
                              </Button>
                              <Button
                                color="dark"
                                outline
                                onClick={() => this.setState({show_series:!this.state.show_series})}
                                active={!this.state.show_series}
                              >
                                riesgo-retorno
                              </Button>
                            </ButtonGroup>
                          </div>
                        </div>
                        <div className="row">
                          {this.state.show_series ?
                            <div className='col-lg-6'>
                              <MultLineTsPlot 
                               data={this.props.port_metrics_compar.data.series}
                               width={600}
                               height={450}
                               xkey='Date'
                               ykeys={this.props.port_metrics_compar.data.names}
                               xtype='category'
                               ytype='number'
                               colors = {colors_sura}
                               percTooltip={false}
                               legend={true ? this.props.port_metrics_compar.data.names.length > 1 : false}
                               ml={50}
                              />
                            </div>
                          :
                            <div className='col-lg-6'>
                              <ScatterPlot
                                data={rets_summ_table}
                                color="#000000"
                                xlabel="Volatilidad"
                                ylabel="Retorno Promedio"
                                xAxisId="Volatilidad Anual."
                                yAxisId="Retorno Promedio Anual."
                                zAxisId='Portafolio'
                                dataName='Portafolio'
                                width={650}
                                ml={50}
                                mr={100}
                                showLabels={true}
                                percTooltip={true}
                                xpercAxis={true}
                                ypercAxis={true}
                                legend={false}
                              />
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="row m-4 justify-content-center">
                      <div className='col'>
                        <hr></hr>
                      </div>
                    </div>
                    <div className="row mt-4 justify-content-center">
                      <div className='col' id="rets">
                        <h5>Análisis de Retornos</h5>
                        <a className='linkcol' href='#exp'>exposición&uarr; {'          '}</a>
                        <a className='linkcol' href='#risk_ret'>riesgo-retorno&uarr; {'          '}</a>
                        {date_ind ? <a className='linkcol' href='#neg_rets'>retornos negativos&darr; {'          '}</a> : null}
                        <a className='linkcol' href='#assets'>activos&darr;</a>
                      </div>
                    </div>
                    <div className="row m-4 justify-content-center">
                      <div className='col-3'>
                          <Input 
                              bsSize="sm"
                              type="select"
                              value={this.state.port_sel || this.props.port_metrics_compar.data.names[0]}
                              onChange={(e)=>this.setState({port_sel:e.target.value})}
                              >
                              {this.props.port_metrics_compar.data.names.map((x,i)=>{
                                return <option key={i}>{x}</option>;
                              })}
                          </Input>
                      </div>
                    </div>
                    <div className="row m-4 justify-content-center">
                      <div className='col-lg-6 p-4'>
                        <div className="row m-4 justify-content-center">
                          <div className='col'>
                            <h6>Retornos Realizados</h6>
                          </div>
                        </div>
                        <div className="row justify-content-center">
                          <div className='col-auto'>
                            <BarPlot 
                              x={real_rets.map(k=>k.Periodo)}
                              y={real_rets.map(k=>k.Retorno)}
                              vertical={false}
                              angle={0}
                              xtype="category" 
                              ytype="number"
                              ypercAxis={true}
                              percTooltip={true}
                              width={500}
                              ml={50}
                              interval={0}
                              height={450}
                              barsize={10}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='col-lg-6 p-4'>
                        <div className="row m-4 justify-content-center">
                          <div className='col'>
                            <h6>Retornos Esperados</h6>
                          </div>
                        </div>
                        <div className="row justify-content-center">
                          <div className='col'>
                            <MultBarPlot 
                              data={expect_rets}
                              nameKey={"Periodo"}
                              vertical={false}
                              angle={0}
                              xtype="category" 
                              ytype="number"
                              colors={colors_sura}
                              ypercAxis={true}
                              percTooltip={true}
                              width={500}
                              ml={50}
                              interval={0}
                              height={450}
                              barsize={10}
                              legend={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {date_ind ?
                    <>
                      <div className="row m-4 justify-content-center">
                        <div className='col'>
                          <hr></hr>
                        </div>
                      </div>
                      <div className="row m-5 justify-content-center">
                        <div className='col' id="neg_rets">
                          <h5>Probabilidades de Retornos Negativos</h5>
                          <a className='linkcol' href='#exp'>exposición&uarr; {'          '}</a>
                          <a className='linkcol' href='#risk_ret'>riesgo-retorno&uarr; {'          '}</a>
                          {date_ind ? <a className='linkcol' href='#neg_rets'>retornos negativos&darr; {'          '}</a> : null}
                          <a className='linkcol' href='#assets'>activos&darr;</a>
                        </div>
                      </div>
                      <div className="row m-5 justify-content-center">
                        <div className='col-lg-6'>
                          <div className="row justify-content-center">
                            <div className={`col-auto ${neg_rets_perc.length<4 ? "mt-4" : "mt-0"}`}>
                              <RenderVirtualTable 
                                data={neg_rets_perc} 
                                to_perc={[false, true, true, true, true, true, true, true, true]}
                                cell_width={["170px", '60px', '60px', '60px', '60px', '60px','60px', '60px', '60px']}
                                item_size={45}
                                style="black"
                              />
                            </div>
                          </div>
                        </div>
                        <div className='col-lg-6 p-2'>
                          <MultLineTsPlot 
                            data={this.props.port_metrics_compar.data.neg_rets_perc}
                            width={500}
                            height={450}
                            xkey='Periodo'
                            ykeys={this.props.port_metrics_compar.data.names}
                            xtype='category'
                            ytype='number'
                            colors={colors_sura}
                            ypercAxis={true}
                            percTooltip={true}
                            dot={true}
                            legend={true ? this.props.port_metrics_compar.data.names.length > 1 : false}
                            ml={50}
                            datetick={false}
                          />
                        </div>
                      </div>
                    </>
                    :null
                    }
                    {rets_summ_assets_table ?
                    <>
                      <div className="row justify-content-center align-items-center">
                        <div className='col p-5'>
                          <hr />
                        </div>
                      </div>
                      <div className="row m-4 justify-content-center align-items-center">
                        <div className='col-md-6' id="assets">
                          <h5><b>Activos</b></h5>
                          <a className='linkcol' href='#exp'>exposición&uarr; {'          '}</a>
                          <a className='linkcol' href='#risk_ret'>riesgo-retorno&uarr; {'          '}</a>
                          <a className='linkcol' href='#rets'>análisis de retornos&uarr;{'          '}</a>
                          {date_ind ? <a className='linkcol' href='#neg_rets'>retornos negativos&uarr;</a> : null}
                        </div>
                      </div>
                      <div className="row mt-4 justify-content-center align-items-center">
                        <div className='col-md-6'>
                          <h6><b>Retornos Realizados</b></h6>
                        </div>
                      </div>
                      <div className="row justify-content-center">
                        <div className='col-lg-1'>
                          <Input bsSize='sm' type="select" value={this.state.ret_period} 
                            onChange={(e)=>this.setState({ret_period:e.target.value})}
                          >
                            {real_rets_assets.map(k=>k.Periodo).map((x,i)=>{
                              return (<option key={i}>{x}</option>);
                            })}
                          </Input>
                        </div>
                      </div>
                      <div className="row mt-4 justify-content-center align-items-start">
                        {Object.keys(real_rets_assets[0]).length>10 ?
                        <div className='col-lg-6'>
                          <div className="row justify-content-center">
                            <div className={`col-auto ${real_rets_assets_trans.length<4 ? "mt-4" : "mt-0"}`}>
                              <RenderVirtualTable 
                                data={real_rets_assets_trans} 
                                to_perc={[false].concat(new Array(real_rets_assets.length).fill(true))} 
                                cell_width={["170px"].concat(new Array(real_rets_assets.length).fill('50px'))}
                                item_size={45}
                                fontsize={10}
                                style="black"
                                />
                            </div>
                          </div>
                        </div>
                        :
                        <div className='col-lg-6'>
                          <div className="row justify-content-center">
                            <div className={`col-auto ${real_rets_assets.length<4 ? "mt-4" : "mt-0"}`}>
                              <RenderVirtualTable 
                                data={real_rets_assets} 
                                to_perc={[false, true, true]} 
                                cell_width={["120px"].concat(new Array(Object.keys(real_rets_assets[0]).length-1).fill('70px'))}
                                item_size={45}
                                fontsize={12}
                                style="black"
                                />
                            </div>
                          </div>
                        </div>
                        }
                        <div className='col-lg-6'>
                          <MultBarPlot 
                            data={sort_array_js(Object.keys(real_rets_assets[0]).filter(k=>k!=='Periodo').map(x=>{
                              return {asset:x, Retorno:real_rets_assets.filter(item=>item.Periodo==this.state.ret_period)[0][x]}
                            }), "Retorno")}
                            nameKey='asset'
                            vertical={true}
                            angle={0}
                            ytype="category" xtype="number"
                            colors={["#000000", "#2803fc"]}
                            xpercAxis={true}
                            percTooltip={true}
                            moneyTooltip={false}
                            width={500}
                            top={30}
                            interval={0}
                            height={500}
                            barsize={10}
                            fontsize={10}
                          />
                        </div>
                      </div>
                      <div className="row mt-5 justify-content-center align-items-center">
                        <div className='col-lg-6'>
                          <h6><b>Riesgo - Retorno</b></h6>
                        </div>
                      </div>
                      <div className="row mt-2 justify-content-center align-items-start">
                        <div className='col-lg-6'>
                          <div className="row justify-content-center">
                            <div className={`col-auto ${rets_summ_assets_table.length<4 ? "mt-4" : "mt-0"}`}>
                              <RenderVirtualTable 
                                data={rets_summ_assets_table} 
                                to_perc={[false, true, true, false, true, false, true]}
                                cell_width={["170px", '60px', '60px', '60px', '60px', '60px', '60px']}
                                item_size={45}
                                fontsize={11}
                                style="black"
                                />
                            </div>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <Label check>
                          <Input 
                              type="checkbox"
                              checked={this.state.show_labels}
                              onChange={(e)=>this.setState({show_labels:!this.state.show_labels})}
                              >
                          </Input>
                          {"  "}ver 
                          </Label>
                          <ScatterPlot
                            data={rets_summ_assets_table}
                            data2={rets_summ_table.map(item=>{
                              return {...item, Activo:item.Portafolio};
                            })}
                            color="#000000"
                            color2="#0303fc"
                            xlabel="Volatilidad"
                            ylabel="Retorno Promedio"
                            xAxisId="Volatilidad Anual."
                            yAxisId="Retorno Promedio Anual."
                            zAxisId='Activo'
                            dataName='Activos'
                            dataName2='Portafolios'
                            labelKey="Activo"
                            showLabels={this.state.show_labels}
                            width={580}
                            ml={10}
                            top={5}
                            percTooltip={true}
                            xpercAxis={true}
                            ypercAxis={true}
                            legend={true}
                          />
                        </div>
                      </div>
                    </>
                    :null
                    }
                </div>
            );
        }
    }
}

export default withRouter(connect(mapStateToProps)(PortComparMetrics));
